import React, { useCallback } from 'react';
import { RiCloseLine } from 'react-icons/ri';

import { SET_EDITOR_PREFERENCES } from '../../actions/setEditorPreferences';
import { useStore } from '../../hooks';
import LayersPanel from '../LayersPanel';

const LayersPanelFlyout = () => {
  const { dispatch, t, editorPreferences = {} } = useStore();

  const close = useCallback(() => {
    dispatch({
      type: SET_EDITOR_PREFERENCES,
      payload: { layersPanelOpen: false },
    });
  }, [dispatch]);

  if (!editorPreferences.layersPanelOpen) {
    return null;
  }

  return (
    <div
      className="respark_layers-panel-flyout"
      role="dialog"
      aria-modal="false"
      aria-label={t('layersPanelTitle')}
    >
      <div className="respark_layers-panel-flyout-header">
        <h2 className="respark_layers-panel-flyout-title">
          {t('layersPanelTitle')}
        </h2>
        <button
          type="button"
          className="respark_layers-panel-flyout-close"
          title={t('layersPanelClose')}
          aria-label={t('layersPanelClose')}
          onClick={close}
        >
          <RiCloseLine size={18} aria-hidden />
        </button>
      </div>
      <LayersPanel t={t} showTitle={false} />
    </div>
  );
};

export default LayersPanelFlyout;
